"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _require = require('yup'),
    number = _require.number,
    object = _require.object,
    string = _require.string;

var RssModel = require('../RssModel');

var RELATIONSHIP_SOURCE = require('../../constant/relationship/source.constant');

var Floor = /*#__PURE__*/function (_RssModel) {
  _inherits(Floor, _RssModel);

  var _super = _createSuper(Floor);

  function Floor() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Floor);

    return _super.call(this, payload);
  } // eslint-disable-next-line class-methods-use-this


  _createClass(Floor, [{
    key: "schema",
    value: function schema() {
      return object().shape({
        id: string().required(),
        floorKey: string().required(),
        buildingId: string().required(),
        buildingKey: string().required(),
        name: string().max(128).trim().required().label('Name'),
        code: string().max(32).trim().nullable()["default"](null).label('Code'),
        size: number().positive().transform(function (value) {
          return Number.isInteger(value) ? parseInt(value, 10) : null;
        }).nullable().max(99999999999)["default"](null).label('Size'),
        groundPlane: number().nullable().transform(function (value) {
          return Number.isInteger(value) ? parseInt(value, 10) : null;
        })["default"](1).max(99999999999).label('Ground Plane'),
        source: string().oneOf(Object.keys(RELATIONSHIP_SOURCE))["default"](RELATIONSHIP_SOURCE.RSS).required().label('Source')
      });
    }
  }]);

  return Floor;
}(RssModel);

module.exports = Floor;